export {default} from './mongo.vue'